import React, { FC } from 'react';
import { MotifModal } from '@ey-xd/motif-react';

import './Modal.scss';

type ModalProps = {
    show: boolean;
    size?: string;
    onClose?: (...args: any[]) => any;
    style?: any;
    className?: string;
    children?: React.ReactNode;
};
const Modal: FC<ModalProps> = ({ show, size, onClose, style, className, ...other }: ModalProps) => (
    <MotifModal
        show={show}
        size={size}
        onClose={onClose}
        style={style}
        className={className}
        {...other}
    />
);
export default Modal;
